export function getRouteAccessRules(route) {
  const matched = route?.matched?.length ? [...route.matched].reverse() : [];

  for (const record of matched) {
    const { permission, permissions, permissionMode } = record.meta || {};

    if (permission || (Array.isArray(permissions) && permissions.length)) {
      return {
        permissions: permissions?.length ? permissions : [permission],
        mode: permissionMode === "all" ? "all" : "any",
      };
    }
  }

  return null;
}

export function canAccessByRules(userPermissions, { permissions, mode }) {
  if (!permissions?.length) {
    return true;
  }

  const perms = userPermissions ?? {};

  if (mode === "all") {
    return permissions.every((key) => !!perms[key]);
  }

  return permissions.some((key) => !!perms[key]);
}
